import { kUserFilesFolderNameMaxLength } from '@/user_files/limits'
import { hasInvalidUserFilesNameCharacter, kInvalidUserFilesNameMessage } from '@/user_files/utils/name-validation'
import { kMaxDroppedFolderDepth } from '@/user_files/drive/constants'

/**
 * Validates dropped-folder name segments against the same rules applied everywhere else a folder
 * name is created (CreateFolderDialog, CreateFolderModal, RenameItemDialog). Drag-and-drop segments
 * come straight from the OS folder name rather than a validated form field, so nothing else checks
 * them before they reach the create-folder request.
 */
export function getInvalidFolderSegmentError(segments: string[]): string | null {
  if (segments.length > kMaxDroppedFolderDepth) {
    return `Folder is nested too deeply (max ${kMaxDroppedFolderDepth} levels)`
  }
  for (const segment of segments) {
    if (hasInvalidUserFilesNameCharacter(segment)) return kInvalidUserFilesNameMessage
    if (segment.length > kUserFilesFolderNameMaxLength) return `Folder name is too long (max ${kUserFilesFolderNameMaxLength} characters)`
  }
  return null
}
